import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "destroyOnClose": "",
      "closable": false,
      "width": 940
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    ref: "pdfRef",
    staticClass: "preview-pdf-box"
  }, [_c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": true
    }
  })], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-checkbox', {
    model: {
      value: _vm.isAgreed,
      callback: function ($$v) {
        _vm.isAgreed = $$v;
      },
      expression: "isAgreed"
    }
  }, [_vm._v(" " + _vm._s(_vm.t('我已阅读并确认《仓储发货指导确认表》')) + " ")]), _c('a', {
    staticClass: "mr-10",
    attrs: {
      "download": _vm.tc('仓储发货指导确认表'),
      "target": "_blank",
      "data-permission": "welcome_guide_confirm_agreement",
      "id": "welcome_guide_confirm_agreement",
      "href": _vm.url + '?download=true&filename=' + _vm.tc('仓储发货指导确认表')
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "download"
    }
  })], 1), _c('a-button', {
    attrs: {
      "disabled": !_vm.isAgreed,
      "data-permission": "welcome_guide_confirm_close",
      "id": "welcome_guide_confirm_close",
      "fbu-analyse-name": $t("\u5173\u95ED")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('关闭')))])], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };